/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AttachmentFilterRequest,
  AttachmentResponse,
  ProjectFilterRequest,
  ProjectResponse,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectSearchClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectSearch
   * @summary Получение отфильтрованных проектов из ЦРМС
   * @request POST:/seismicImport/api/v1/ProjectSearch/projects
   * @secure
   */
  projectSearchGetProjects = (data: ProjectFilterRequest, params: RequestParams = {}) =>
    this.http.request<ProjectResponse[], Record<string, string>>({
      path: `/seismicImport/api/v1/ProjectSearch/projects`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSearch
   * @summary Получение вложений по идентификатору проекта
   * @request POST:/seismicImport/api/v1/ProjectSearch/projectAttachments
   * @secure
   */
  projectSearchGetProjectAttachments = (
    data: AttachmentFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<AttachmentResponse[], any>({
      path: `/seismicImport/api/v1/ProjectSearch/projectAttachments`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
